//元素设置相关样式
import './esetting.css';

//图片元素弹窗插件样式
import './fancyboc.css';

//元素样式
import './style.css';


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/css/index.js